<div class="same-line">
  <label class="material-checkbox">
    <input
      type="checkbox"
      [checked]="isChecked"
      (change)="onToggle($event)"
      [disabled]="isDisabled"
      [attr.data-cy]="dataCy"
    />
    <span class="checkmark"></span>
  </label>
  <ng-content></ng-content>
</div>
